The upper limit of advertisement brandings to return from the start of the list.

Defaults to 10 if neither `first` nor `last` are specified.
Excess advertisement brandings will be trimmed from the end of the list.

`first` and `last` cannot be specified in the same query.
